import { Box, Button, Modal, Typography } from '@material-ui/core'
import React from 'react'

const DeleteModal = ({ setOpen, open , deleteStatus }) => {
    
const style = {
    main: {
    position:'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    borderRadius: '15px',
    p: 4
    },
    footer:{
        display: 'flex',
        justifyContent: 'space-between'
    }
  };
  
  const handleClose = () => setOpen(false);
  return (
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style.main}>
            <Typography variant="h5" style={{textAlign: 'center', marginBottom: '1.4rem'}}>
                Are You Sure, You want to Delete?
            </Typography>
            <Box sx={style.footer}>
                <Button variant='contained' onClick={() => deleteStatus(true)}>Delete</Button>
                <Button variant='outlined' onClick={handleClose}>Cancel</Button>
            </Box>
        </Box>
      </Modal>
  )
}

export default DeleteModal